"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkMessageFormatter = exports.getVueRuntimeContext = void 0;
var runtime_context_1 = require("./runtime-context");
Object.defineProperty(exports, "getVueRuntimeContext", { enumerable: true, get: function () { return runtime_context_1.getVueRuntimeContext; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "sdkMessageFormatter", { enumerable: true, get: function () { return utils_1.sdkMessageFormatter; } });
//# sourceMappingURL=index.js.map